import environment from '@/environment'

/**
 * Deep link to a local-PQ run's Temporal workflow, for support/troubleshooting.
 *
 * The prequalification backend names each run's workflow `pq-{runId}` and executes it
 * in the `{environment}.ersgn` Temporal namespace (e.g. `staging.ersgn`,
 * `production.ersgn`), so the namespace tracks `environment.environmentName`.
 */
export function makeTemporalWorkflowLink(runId: string): string {
  const namespace = `${environment.environmentName}.ersgn`
  return `${environment.observability.temporalUiBaseUrl}/namespaces/${namespace}/workflows/pq-${runId}`
}
